import React from 'react';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { Surface } from '@americanexpress/dls-react';
import { RoomsContextProvider } from '../contexts/roomsContext';
import RoomsSelector from './Rooms/RoomsSelector';
import { MODULE_NAME } from '../constants/moduleName';
import { ConfigContextProvider } from '../contexts/configContext';
import { RefsContextProvider } from '../contexts/refsContext';
import { mosaicContext } from '../contexts/mosaicContext';

const TravelSearchRoomsTravelers = ({
  defaultChildAge,
  defaultValue,
  element,
  errors,
  hasAdultAgesHint,
  hasChildrenAges,
  hasInfants,
  hasInfantsAges,
  hasLabel,
  hasPets,
  hasRooms,
  id: parentId,
  isMosaicDesign,
  inputLabel,
  languageData,
  lob,
  locale,
  maxAdults,
  maxChildAge,
  maxChildren,
  maxCombinedChildrenAndInfants,
  maxInfants,
  maxRooms,
  maxTravelersCap,
  maxTravelersPerRoom,
  onChange,
  onToggleVisibility,
  shouldAppendDropdownLabel,
  theme,
  value,
}) => (
  <IntlProvider locale={locale} messages={languageData}>
    <mosaicContext.Provider value={isMosaicDesign}>
      <ConfigContextProvider
        {...{
          defaultChildAge,
          defaultValue,
          element,
          errors,
          hasAdultAgesHint,
          hasChildrenAges,
          hasInfants,
          hasInfantsAges,
          hasLabel,
          hasPets,
          hasRooms,
          inputLabel,
          lob,
          maxAdults,
          maxChildAge,
          maxChildren,
          maxCombinedChildrenAndInfants,
          maxInfants,
          maxRooms,
          maxTravelersCap,
          maxTravelersPerRoom,
          onChange,
          onToggleVisibility,
          parentId,
          shouldAppendDropdownLabel,
          theme,
          value,
        }}
      >
        <RoomsContextProvider>
          <RefsContextProvider>
            <Surface
              variant={theme === 'blue' ? 'fg-brand' : 'foreground'}
              className="width-full"
              style={{ display: !(theme === 'blue') && 'contents' }}
            >
              <RoomsSelector />
            </Surface>
          </RefsContextProvider>
        </RoomsContextProvider>
      </ConfigContextProvider>
    </mosaicContext.Provider>
  </IntlProvider>
);

TravelSearchRoomsTravelers.propTypes = {
  defaultChildAge: PropTypes.string,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
  element: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  hasAdultAgesHint: PropTypes.bool,
  hasChildrenAges: PropTypes.bool,
  hasInfants: PropTypes.bool,
  hasInfantsAges: PropTypes.bool,
  hasLabel: PropTypes.bool,
  hasPets: PropTypes.bool,
  hasRooms: PropTypes.bool,
  id: PropTypes.string,
  isMosaicDesign: PropTypes.bool,
  inputLabel: PropTypes.string,
  languageData: PropTypes.shape({}).isRequired,
  lob: PropTypes.string,
  locale: PropTypes.string.isRequired,
  maxAdults: PropTypes.number,
  maxChildAge: PropTypes.number,
  maxChildren: PropTypes.number,
  maxCombinedChildrenAndInfants: PropTypes.number,
  maxInfants: PropTypes.number,
  maxRooms: PropTypes.number,
  maxTravelersCap: PropTypes.number,
  maxTravelersPerRoom: PropTypes.number,
  onChange: PropTypes.func,
  onToggleVisibility: PropTypes.func,
  shouldAppendDropdownLabel: PropTypes.bool,
  theme: PropTypes.string,
  value: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
};

TravelSearchRoomsTravelers.defaultProps = {
  defaultChildAge: '8',
  defaultValue: [
    {
      adults: 1,
      children: [],
      infants: [],
    },
  ],
  element: 'number-of-travelers',
  hasAdultAgesHint: false,
  hasChildrenAges: true,
  hasInfants: false,
  hasInfantsAges: true,
  hasLabel: false,
  hasPets: false,
  hasRooms: true,
  id: '',
  isMosaicDesign: false,
  lob: '',
  maxAdults: 4,
  maxChildAge: 17,
  maxChildren: 6,
  maxCombinedChildrenAndInfants: undefined,
  maxInfants: 6,
  maxRooms: 4,
  maxTravelersCap: undefined,
  onChange: () => ({}),
  onToggleVisibility: () => ({}),
  shouldAppendDropdownLabel: true,
  theme: 'blue',
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  await Promise.all([
    dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
  ]);
};

TravelSearchRoomsTravelers.holocron = {
  name: MODULE_NAME,
  loadModuleData,
};

const hocChain = compose(
  oneAppModuleWrapper(MODULE_NAME)
);

export { TravelSearchRoomsTravelers as TestableTravelSearchRoomsTravelers };

export default hocChain(TravelSearchRoomsTravelers);
